import { gql } from "@apollo/client";

export const GENERATE_UPLOAD_URL_MUTATION = gql`
  mutation GenerateUploadUrl($input: GenerateUploadUrlInput!) {
    generateUploadUrl(input: $input) {
      uploadUrl
      fileKey
      fileId
    }
  }
`;

export const CONFIRM_UPLOAD_MUTATION = gql`
  mutation ConfirmUpload($input: ConfirmUploadInput!) {
    confirmUpload(input: $input) {
      id
      file_name
      file_url
      mime_type
      file_size
    }
  }
`;

// Create Work Order Mutation

export const GENERATE_DOCUMENT_MUTATION = gql`
    mutation GenerateDocument($input: GenerateDocumentInput!) {
        generateDocument(input: $input) {
            content
            provider
            model
            tokensUsed
        }
    }
`;

// Delete Asset Mutation

export const GENERATE_DOCUMENT_UPLOAD_URL_MUTATION = gql`
mutation GenerateDocumentUploadUrl($input: UploadDocumentInput!) {
    generateDocumentUploadUrl(input: $input) {
        uploadUrl
        fileKey
        fileId
        fileUrl
        alreadyExists
        document {
            id
            name
            mime_type
            size
            source
            checksum
            document_type
            notes
            tags
            asset_text
            location_text
            regex {
                assetIds
                locationIds
            }
        }
    }
}
`;

export const CONFIRM_DOCUMENT_UPLOAD_MUTATION = gql`
mutation ConfirmDocumentUpload($input: ConfirmDocumentUploadInput!) {
    confirmDocumentUpload(input: $input) {
        success
        count
        totalSize
        documents {
            id
            name
            mime_type
            size
            storage_path
            source
            checksum
            regex {
                assetIds
                assetNames
                productTypes
                productCategories
                locationIds
                locationNames
                manufacturers
                parentLocationIds
                parentLocationNames
                fedFromIds
                inspectionIds
            }
        }
    }
}
`;

export const CONFIRM_EVIDENCE_UPLOAD_MUTATION = gql`
mutation ConfirmEvidenceUpload($input: ConfirmEvidenceUploadInput!) {
  confirmEvidenceUpload(input: $input) {
    success
    document {
      id
      name
      mime_type
      size
      storage_path
      source
      checksum
      document_type
      regex {
        assetIds
        assetNames
        productTypes
        productCategories
        locationIds
        locationNames
        manufacturers
        parentLocationIds
        parentLocationNames
        fedFromIds
      }
    }
    taskResults {
      taskId
      assetId
      assetName
      result
      pass_fail {
        question
        type
        answer
        found
        valid
      }
    }
    errors
  }
}
`;

export const DELETE_DOCUMENT_MUTATION = gql`
mutation DeleteDocument($input: DeleteDocumentInput!) {
    deleteDocument(input: $input) {
        success
        count
        notFound
        deleted {
            id
            name
        }
    }
}
`;

export const UPDATE_DOCUMENT_MUTATION = gql`
mutation UpdateDocument($input: UpdateDocumentInput!) {
    updateDocument(input: $input) {
        id
        name
        mime_type
        size
        storage_path
        source
        checksum
        tags
        notes
        asset_text
        location_text
        document_type
    }
}
`;

export const RE_EXTRACT_DOCUMENT_MUTATION = gql`
  mutation ReExtractDocument($documentId: ID!) {
    reExtractDocument(documentId: $documentId) {
      success
      id
    }
  }
`;

export const CREATE_DOCUMENT_FOLDER_MUTATION = gql`
  mutation CreateDocumentFolder($input: CreateDocumentFolderInput!) {
    createDocumentFolder(input: $input) {
      id
      locationId
      parentFolderId
      name
      documentCount
      createdAt
    }
  }
`;

export const RENAME_DOCUMENT_FOLDER_MUTATION = gql`
  mutation RenameDocumentFolder($input: RenameDocumentFolderInput!) {
    renameDocumentFolder(input: $input) {
      id
      locationId
      parentFolderId
      name
      documentCount
      createdAt
    }
  }
`;

export const DELETE_DOCUMENT_FOLDER_MUTATION = gql`
  mutation DeleteDocumentFolder($id: ID!) {
    deleteDocumentFolder(id: $id) {
      success
      id
    }
  }
`;

export const MOVE_DOCUMENTS_TO_FOLDER_MUTATION = gql`
  mutation MoveDocumentsToFolder($input: MoveDocumentsToFolderInput!) {
    moveDocumentsToFolder(input: $input) {
      success
      count
    }
  }
`;

export const MOVE_DOCUMENT_FOLDERS_MUTATION = gql`
  mutation MoveDocumentFolders($input: MoveDocumentFoldersInput!) {
    moveDocumentFolders(input: $input) {
      success
      count
    }
  }
`;

export const UPDATE_DOCUMENT_ETL_STATUS_MUTATION = gql`
  mutation UpdateDocumentEtlStatus($input: UpdateDocumentEtlStatusInput!) {
    updateDocumentEtlStatus(input: $input) {
      success
      id
    }
  }
`;
